import { apiPrefix } from '../constants'

export default {
  addRecipe: {
    type: 'post',
    url: `${apiPrefix}recipeBunch`,
  },
  deleteRecipe: {
    type: 'delete',
    url: `${apiPrefix}recipeBunch`,
  },
  getRecipes: {
    type: 'get',
    url: `${apiPrefix}recipeBunches`,
  },
  getRecipe: {
    type: 'get',
    url: `${apiPrefix}recipeBunch`,
  },
  updateRecipe: {
    type: 'put',
    url: `${apiPrefix}recipeBunch`,
  },
  getRecipeHeaders: {
    type: 'get',
    url: `${apiPrefix}recipeHeaders`,
  },
  // - uses same route but will be called with additional params
  addRecipeVariant: {
    type: 'post',
    url: `${apiPrefix}recipeBunch`,
  },
  deleteRecipeVariant: {
    type: 'delete',
    url: `${apiPrefix}recipeBunch`,
  },
  getRecipeVariants: {
    type: 'get',
    url: `${apiPrefix}recipeBunch`,
  },
  updateRecipeVariant: {
    type: 'put',
    url: `${apiPrefix}recipeBunch`,
  },
  // -
  recipeCommand: {
    type: 'post',
    url: `${apiPrefix}recipeBunch`,
  },
}
